





























































































































import { computed, defineComponent, reactive } from "@vue/composition-api";
import { ApiResult, post } from "../helpers/api";
import { useRouter } from "../router";
import { getStore } from "../store";

const componentName = "Sharing";

export default defineComponent({
    name: componentName,

    setup(context) {
        const { route } = useRouter();

        const state = reactive({
            shareProcess: null,
            shareError: null
        });

        const store = getStore();

        const shareStatus = computed(() => store.state.shareInfo?.share?.status);

        const senderFullName = computed(() => {
            if (store.state.shareInfo.user) {
                let fullName = `${store.state.shareInfo.user.givenName || ""} ${
                        store.state.shareInfo.user.lastName || ""
                    }`.trim();

                if (fullName == "") {
                    fullName = store.state.shareInfo.user.email;
                }

                return fullName;
            }
            return "";
        });

        const sendRequest = async (
            endPoint: string,
            actionName: "accept" | "reject"
        ) => {
            state.shareProcess = actionName;

            try {
                const result = (await post(
                    endPoint,
                    null,
                    route.value.query.c as string
                ).then((x) => x.data)) as ApiResult<any>;

                state.shareProcess = "";
                store.commit("updateSharingInfo", null);

                if (result.result == "OK") {
                    const newStatus = actionName == "accept" ? "ACCEPTED" : "REJECTED";
                    store.commit("updateSharingStatus", newStatus);
                }
                else {
                    state.shareError = "INVALID";
                }
            }
            catch {
                state.shareProcess = "";
                state.shareError = "SERVER-ERROR";
                store.commit("updateSharingInfo", null);
            }
        };

        const onAccept = () => {
            sendRequest("/_api/v1/sharing/accept", "accept");
        };

        const onReject = () => {
            sendRequest("/_api/v1/sharing/reject", "reject");
        };

        const shareInfo = computed(() => store.state.shareInfo);

        return {
            state,
            shareStatus,
            senderFullName,
            shareInfo,

            onAccept,
            onReject
        };
    }
});
